<div class="terminal" #terminalContainerRef>
  <div class="output-window"></div>

  <div class="input-window">
    @if (busy()) {
      <div class="command-line busy" role="status">
        <div class="terminal-prompt"><span class="spinner" aria-hidden="true"></span> running… {{ elapsedSeconds() }}s</div>
        <div class="terminal-prompt busy-hint">(Ctrl+C to stop waiting)</div>
      </div>
    }

    <div class="command-line" [hidden]="busy()">
      <div class="command-line-arrow">
        <div class="terminal-prompt">{{ '$ > ' }}</div>
      </div>

      <textarea
        [appAutoSize]="true"
        [minRows]="1"
        (keyup)="onKeyUp($event)"
        (keypress)="onKeyPress($event)"
        #textareaRef
        [disabled]="busy()"
        class="input-command"
      ></textarea>
    </div>
  </div>
  <div class="click-capture-section" (click)="focusInputLine()" role="presentation"></div>
</div>
